import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GivePointMethodTypeEnum } from '@app-shared/enums';
import { MileageService } from '@user/core/services';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-ocr-point-modal',
  templateUrl: './ocr-point-modal.component.html',
  styleUrls: ['./ocr-point-modal.component.scss']
})
export class OcrPointModalComponent implements OnInit {
  @Input() isShowModal = false;
  @Input() resultOCR = 0;
  @Input() isSubmitted = false;
  @Input() messageToUser: any = '';
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() submitMileage = new EventEmitter<any>();
  @Input() ocrId: number | null = null;
  @Input() canContact: boolean = false;
  isSubmittingContact = false;
  @Output() contactSuccess = new EventEmitter<string>();
  get message(): string {
    return this.messageToUser?.message || this.messageToUser?.[0]?.message?.[0] || '';
  }

  constructor(
    private mileageService: MileageService,
  ) { }

  ngOnInit(): void {
  }

  onCloseModal(): void {
    this.closeModal.emit(false);
  }

  onSubmitMileage(): void {
    this.submitMileage.emit(GivePointMethodTypeEnum.RECEIPT_APPROVAL);
  }

  onSubmitContactMileage(): void {
    if (!this.ocrId || this.isSubmittingContact) {
      return;
    }

    this.isSubmittingContact = true;

    this.mileageService.requestPoints(this.ocrId)
      .pipe(
        finalize(() => {
          this.isSubmittingContact = false;
        })
      )
      .subscribe((resp: any) => {
        this.contactSuccess.emit(resp?.message || '');
      });
  }
}
